module.exports = __webpack_public_path__ + "media/images/sac_logo_fr-e89f75c6.svg";